var ExchangeDesiredSegmentsScreen = (function ($) {

    ExchangeDesiredSegmentsScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_hash = options['order_hash'] || null;
        that.order_passenger_hash = options['order_passenger_hash'] || null;
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.order_url = options['order_url'];
        that.class = {
            disabled: 'disabled',
            error: 'error'
        };
        that.selectors = {
            desired_segments_screen_wrapper: '.js-desired-segments-screen-wrapper',
            select_desired_segment_wrapper: '.js-select-desired-segment-wrapper',
            select_desired_segment: '.js-select-desired-segment',

            drawer_segments_trigger: '.js-drawer-segments-trigger',
            variant: '.js-variant',
            variant_segments_wrapper: '.js-segments-wrapper',
            variant_segment: '.js-segment',
            variant_route: '.js-variant-route',
            drawer_localtime_disclaimer: '.js-drawer-localtime-disclaimer'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
    };

    ExchangeDesiredSegmentsScreen.prototype.init = function (data) {
        var that = this,
            deferred = $.Deferred();

        that.__getDesiredSegments(data).done(function (response) {
            if (true === response) {
                that.__initEvents();
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    ExchangeDesiredSegmentsScreen.prototype.isValid = function () {
        var that = this,
            selected_segments_count = that.$select_desired_segment.filter(':checked').length;

        if (selected_segments_count === 0) {
            that.$select_desired_segment_wrapper.addClass(that.class.error).find('.' + that.class.error).text(that.locales.desired_segment_not_selected);
            return false;
        }

        return true;
    };

    ExchangeDesiredSegmentsScreen.prototype.getData = function () {
        return {
            value: this.$select_desired_segment.filter(':checked').parent().find('.js-variant').data('hash')
        };
    };

    ExchangeDesiredSegmentsScreen.prototype.showError = function () {
        $.uiModal({
            html: this.modals['calculate_cost_failed']
        });
    };

    /**
     * @private
     */
    ExchangeDesiredSegmentsScreen.prototype.__initEvents = function () {
        var that = this;

        that.$select_desired_segment.on('change', function () {
            if (that.$select_desired_segment.filter(':checked').length > 0) {
                that.$select_desired_segment_wrapper.removeClass(that.class.error);
            }
        });

        that.$select_desired_segment_wrapper.on('click', that.selectors.drawer_segments_trigger, function (e) {
            e.preventDefault();
            that.__showSegmentsDetails(this);
        });
    };

    /**
     * @private
     */
    ExchangeDesiredSegmentsScreen.prototype.__getDesiredSegments = function (data) {
        var that = this,
            check_desired_segments_url = that.order_url + '/exchange/desired/segments',
            deferred = $.Deferred();

        $.get(check_desired_segments_url, data).done(function (response, textStatus, jqXHR) {
            if (200 === jqXHR.status && response.length) {
                that.$wrapper.html(response);
                that.$select_desired_segment_wrapper = that.$wrapper.find(that.selectors.select_desired_segment_wrapper);
                that.$select_desired_segment = that.$wrapper.find(that.selectors.select_desired_segment);
                
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    ExchangeDesiredSegmentsScreen.prototype.__showSegmentsDetails = function (trigger) {
        var that = this,
            $trigger = $(trigger),
            $variant = $trigger.parents(that.selectors.variant),
            drawer_header = $variant.find(that.selectors.variant_route).find('.variant-point.departure .location-city').text() + ' — ' + $variant.find(that.selectors.variant_route).find('.variant-point.arrival .location-city').text(),
            variant_header_description = $variant.find(that.selectors.variant_route).find('.duration').text(),

            $drawer_content = $variant.find(that.selectors.variant_segments_wrapper).clone(),

            $variant_segments = $drawer_content.find(that.selectors.variant_segment),
            drawer_fullscreen = $variant_segments.length > 1,
            drawer_fluid = !drawer_fullscreen,
            drawer_disable_scroll = !drawer_fullscreen;

        $drawer_content.append($variant.find(that.selectors.drawer_localtime_disclaimer).html());

        $.uiDrawer({
            position: 'right',
            fluid: drawer_fluid,
            disable_content_scroll: drawer_disable_scroll,
            mobile_fullscreen: drawer_fullscreen,
            header_contrast: true,
            custom_class: 'narrow variant-card no-radius drawer-segments',
            header_title: drawer_header,
            header_description: variant_header_description,
            content: $drawer_content.html()
        });
    };

    // EVENTS

    ExchangeDesiredSegmentsScreen.prototype.beforeUnload = function () {
        var that = this;

        that.$select_desired_segment_wrapper.addClass(that.class.disabled);
    };

    ExchangeDesiredSegmentsScreen.prototype.afterLoad = function () {
        var that = this;

        that.$select_desired_segment_wrapper.removeClass(that.class.disabled);
    };

    return ExchangeDesiredSegmentsScreen;
})($);
